import Codechef from './codingimg/codechef.png';
import Geeks from './codingimg/geeks.png';
import Leetcode from './codingimg/leetcode.png';
import Github from './codingimg/git.png';
import CodeForces from './codingimg/codeforces.png';
import Hacker from './codingimg/hackerrank.png';

const image = [
    {
        id: 1,
        src: Codechef,
        alt: 'codechef',
        lnk: 'https://www.codechef.com/users/shruti_234'
    },
    {
        id: 2,
        src: Geeks,
        alt: 'geeksforgeeks',
        lnk: 'https://auth.geeksforgeeks.org/user/shrutiyadav26072002/'
    },
    {
        id: 3,
        src: Leetcode,
        alt: 'leetcode',
        lnk: 'https://leetcode.com/shrutiyadav26072002/'
    },
    {
        id: 4,
        src: Github,
        alt: 'github',
        lnk: 'https://github.com/shruti01052002'
    },
    {
        id: 5,
        src: CodeForces,
        alt: 'codeforces',
        lnk: 'https://codeforces.com/profile/shruti_234'
    },
    {
        id: 6,
        src: Hacker,
        alt: 'hackerrank',
        lnk: 'https://www.hackerrank.com/shrutiyadav26071?hr_r=1'
    }
];
export default image;